import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { logoutRoutine } from 'state/account/account.routines';
import { authTokenSelector } from 'state/account/account.selectors';

const Logout = () => {
    const dispatch = useDispatch();
    const { token } = useSelector(authTokenSelector);
    console.log('logout token', token);
    useEffect(() => {
        if (token) {
            dispatch(logoutRoutine());
        }
    }, [token]);

    if (!token) {
        return <Redirect to="/" />;
    }

    return <>Logout</>;
};

export default Logout;
